import request from '@/utils/request'
// 获取logo
export function getPartnersLogo (query) {
  return request({
    url: '/partners/query',
    method: 'get',
    params: query
  })
}
// 获取列表
export function getPartnersList (query) {
  return request({
    url: '/cooperate/case/query',
    method: 'get',
    params: query
  })
}
// 列表详情
export function getPartnersListDetail (query) {
  return request({
    url: '/cooperate/case/get',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/partners.js